import { useEffect, useState } from 'react';
import contentsClient from '../client/medq-contents';

type Institution = {
  name: string;
  _id: string;
}

type RegionMap = Record<string, {institutions: Institution[]}>;

export type Region = {
  id: string;
  institutions: Institution[];
}

export type RegionDAO = {
  data: RegionMap;
  institutions: Institution[];
  loading: boolean;
  getList: () => Region[];
}

export default function useRegions(): RegionDAO {
  const [result, setResult] = useState<RegionDAO>({
    data: {},
    institutions: [],
    loading: true,
    getList: () => [],
  });
  useEffect(() => {
    contentsClient.institutionByRegion().then((byRegion) => {
      byRegion.sort((a, b) => (a.region < b.region ? -1 : 1));
      byRegion.forEach((item) => item.institutions.sort((a, b) => (a.name < b.name ? -1 : 1)));
      const data: RegionMap = {};
      let institutions: Institution[] = [];
      const regions: Region[] = [];
      byRegion.forEach((item) => {
        const institutionsArray = item.institutions.map((inst) => ({
          _id: inst.id,
          name: inst.name,
        }));
        data[item.region] = {
          institutions: institutionsArray,
        };
        regions.push({
          id: item.region,
          institutions: institutionsArray,
        });
        institutions = [...institutions, ...institutionsArray];
      });
      setResult({
        data,
        loading: false,
        institutions,
        getList: () => regions,
      });
    });
  }, []);
  return result;
}
